<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="/img/avatars/user.png"
        class="img-avatar"
        alt="imagen de usuario" />
    </template>\
    <template slot="dropdown">
      <b-dropdown-item to="/profile"><i class="fa fa-user" /> Perfil </b-dropdown-item>
     <!-- <b-dropdown-item><i class="fa fa-tasks" /> Seguridad
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-list" /> Bitacora
      </b-dropdown-item>-->
      <b-dropdown-divider />
      <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Cerrar Sesión</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { mapActions } from 'vuex';

import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      
       }
  },
   computed: {
    
  },
  methods: {
    ...mapActions('authentication', [
      'logout',
    ]),
  },
 
}
</script>
